import React from 'react';
import { Typography } from '@material-ui/core';

function Preferences() {
  return (
    <div>
      <Typography variant="h5">
        Preferences page is coming soon.
      </Typography>
    </div>
  );
}

export default Preferences;
